import React from "react"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"

interface CountrySelectProps {
    value?: string
    onValueChange: (value: string) => void
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
    value = "all",
    onValueChange,
}) => {
    return (
        <Select onValueChange={onValueChange} defaultValue={value}>
            <SelectTrigger className="w-[180px] rounded-full">
                <SelectValue placeholder="All Countries" />
            </SelectTrigger>
            <SelectContent className="z-[102]">
                <SelectItem value="all">All Countries</SelectItem>
                <SelectItem value="Scotland">Scotland</SelectItem>
                <SelectItem value="Canada">Canada</SelectItem>
            </SelectContent>
        </Select>
    )
}
